const hero_mixin = {
	methods: {
		back_to_position: function (el) {
			var x = 0
			if (this.current.position == 0) x = -(el.offsetWidth + 8)
			if (this.current.position == 2) x = (el.offsetWidth + 8)
			el.style.webkitTransform = el.style.transform = 'translate(' + x + 'px, ' + 0 + 'px)'
			el.setAttribute('data-x', x)
			el.setAttribute('data-y', 0)
		}
	}
}

export default hero_mixin